import { Heading, Box } from '@chakra-ui/react'
import Truncate from 'react-truncate'

import { PressReleasesData } from 'config/common/baseModel'

import { formatDate } from 'utils/formatDate'

import { ItemComponentPropTypes } from '.'
import ArticleFooter from './components/ArticleFooter'

const DetailDrawerListPressRelease = ({
  item,
  handleSelect,
}: ItemComponentPropTypes<Record<PressReleasesData, any>>) => {
  const { title, datePublished, description, sourceUrl, link } = item

  const externalLink = sourceUrl ?? link

  return (
    <Box
      px={8}
      py={4}
      borderBottom='1px solid'
      borderColor='gray.100'
      cursor='pointer'
      onClick={() => handleSelect(item)}
      _hover={{
        bg: 'gray.100',
      }}
    >
      <Box
        mb={1}
        display='flex'
        alignItems='center'
        fontSize='xs'
        fontWeight={600}
        textTransform='uppercase'
        color='gray.700'
      >
        <Box mr={2}>{formatDate(datePublished)}</Box>
      </Box>
      <Heading fontSize='md' mb={2} fontWeight={500}>
        {title}
      </Heading>
      <Box mb={4} color='gray.800' fontSize='sm'>
        <Truncate lines={3} ellipsis={<span>...</span>} trimWhitespace={true}>
          {description}
        </Truncate>
      </Box>
      <ArticleFooter externalLink={externalLink as string} />
    </Box>
  )
}

export { DetailDrawerListPressRelease }
